import { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

import UserLayout from './_layout';
import { settingsRoutes } from './settings/_routes';

const ProfileSecurityPage = lazy(() => import('./security'));

export const userRoutes: RouteObject[] = [
  {
    element: <UserLayout />,
    children: [
      {
        path: '/profile/security',
        element: <ProfileSecurityPage />,
        handle: { breadcrumb: 'Security' },
      },
      ...settingsRoutes,
    ],
  },
];
